export const termsConditionsLoading =  ({store})  => store.termsConditionsReducer.loading;

export const termsConditionsError =  ({store})  => store.termsConditionsReducer.error;

export const termsConditionsData =  ({store})  => store.termsConditionsReducer.data;